import React from 'react';
import styled from 'styled-components';


const NormalSmallBtnBlock = styled.button`
    height: ${props => props.height || '40px'};
    margin-top: ${props => props.marginTop || '0px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-right: ${props => props.marginRight || '0px'};
    font-size: ${props => props.fontSize || '22px'};
    font-weight: ${props => props.fontWeight || '500'};
    border-radius: ${props => props.borderRadius || '20px'};
    color: ${props => props.textColor || '#111'} ;
    background-color: ${props => props.bgColor || '#ffc742'};
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid ${props => props.bgColor || '#ffc742'};
    width: ${props => props.width || '110px'};
    float: ${props => props.float || 'none'};
    min-width: ${props => props.minWidth || '0px'};
    line-height: ${props => props.lineHeight || 'normal'}; 
    padding: ${props => props.padding || '0'}; 
    display: ${props => props.display || 'block'}
    overflow: hidden;
`;

const NormalSmallBtn = ({ height, marginTop, marginBottom, marginRight, fontSize,
    fontWeight, width, minWidth, bgColor, textColor, display,
    borderRadius, float, text, img, lineHeight, padding, onClick, html = false }) => {

    // console.log("img : " + img);
    return (
        <NormalSmallBtnBlock
            height={height}
            marginTop={marginTop}
            marginRight={marginRight}
            marginBottom={marginBottom}
            fontSize={fontSize}
            fontWeight={fontWeight}
            borderRadius={borderRadius}
            bgColor={bgColor}
            textColor={textColor}
            display={display}
            width={width}
            minWidth={minWidth}
            lineHeight={lineHeight}
            float={float}
            img={img}
            padding={padding}
            onClick={onClick}>
            {!!html?<div dangerouslySetInnerHTML={{__html: text }} />:text}
        </NormalSmallBtnBlock>
    );
};

export default NormalSmallBtn;
